<div class="col-md-8">
  <button class="btn-custom" (click)="openStockBalance()" *ngIf="showButton('stock-balance')">Stock Balance</button>
  <button class="btn-custom" (click)="openStockMovement()" *ngIf="showButton('stock-movement')">Stock Movement</button>
  <button class="btn-custom" (click)="openProductAging()" *ngIf="showButton('product-aging')">Product Aging</button>
</div>
